import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { createGroupTypeDropdown, REVIEW_STATUS_DROPDOWN } from 'constants/filterConfigs';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';
import { GroupAccessMode } from 'services/api/group';

export function getFilterSections(
  snfGroupType: GroupType | undefined,
  profile: Profile,
  { showGroupFilter = true }: { showGroupFilter?: boolean } = {}
): FilterSection[] {
  const filters = [
    ...(showGroupFilter && snfGroupType
      ? [
          {
            ...createGroupTypeDropdown(snfGroupType, {
              clientId: profile.actingClient.id,
              accessModes: [GroupAccessMode.Allowed],
            }),
            name: 'group_id',
          },
        ]
      : []),
    REVIEW_STATUS_DROPDOWN,
  ];

  return [{ title: 'Filters', filters }];
}
